import { supabase } from './supabase';
import type { FeedbackRecord } from './api';

const FEEDBACK_TABLE = 'feedback';
const MAX_FEEDBACK_LIMIT = 500;

export async function listFeedback(
  limit = MAX_FEEDBACK_LIMIT
): Promise<FeedbackRecord[]> {
  const { data, error } = await supabase
    .from(FEEDBACK_TABLE)
    .select('id, user_id, category, message, page, created_at')
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) {
    throw error;
  }

  return (data as FeedbackRecord[]) ?? [];
}

export async function deleteFeedback(id: string): Promise<void> {
  const { error } = await supabase.from(FEEDBACK_TABLE).delete().eq('id', id);
  if (error) {
    throw error;
  }
}
